var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJdpLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 903.2 134.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #000f02;\n      }\n\n      .st1 {\n        fill: #00828d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.1,76.8c0,36.9-20.1,57.5-55.5,57.5S1.3,115.6,0,82.7h37.5c.9,11,7.2,17.2,17.4,17.2s16.6-7.9,16.6-21.9V2.8h38.6v74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169,2.8c41.2,0,70,25.2,70,64.1s-28.8,64.5-70,64.5h-54.1V2.8h54.1,0ZM169,97.8c18,0,31.2-12.9,31.2-30.8s-13.2-30.5-31.2-30.5h-16.1v61.3h16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296,2.8c36.3,0,57.9,18.2,57.9,49s-22,50-59.2,50h-14.8v29.7h-38V2.8h54.1ZM295.6,69.4c12.3,0,19.7-6.6,19.7-17.6s-7.4-16.7-19.7-16.7h-15.7v34.2h15.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.4,67.2c0,38-28.8,67.2-69.5,67.2s-69.5-29.1-69.5-67.2S379.2,0,419.9,0s69.4,29.1,69.4,67.2ZM450.6,67.2c0-16.8-12.7-31.4-30.6-31.4s-30.6,14.6-30.6,31.4,12.7,31.4,30.6,31.4,30.6-14.6,30.6-31.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.3,132.3h-36.3l-23.1-74-23.1,74h-36.5L477.6,2.8h40.5l20.1,70.4,24.2-70.4h31l24,70.6,20.2-70.6h40.5l-40.9,129.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M715.1,52h53v30.7h-53v16.8h61.9v32h-99.9V2.8h99.9v32h-61.9v17.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M817.9,97.6v33.9h-38V2.8h58.3c34.8,0,56.2,17.2,56.2,46.7s-7.8,30.8-21.8,39.4l30.7,42.6h-46l-22.9-33.9h-16.5ZM837.7,64c10.4,0,18.2-5.9,18.2-14.8s-7.8-14-18.2-14h-19.9v28.8h19.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdpLogo);
export default __webpack_public_path__ + "static/media/jdp-logo.0683763b0fe94086e6a35b25e2a657cd.svg";
export { ForwardRef as ReactComponent };